import React from 'react'
import styled from 'styled-components'
import { Text } from 'sutra/components/Text/Text'
import { Toggle } from 'sutra/components/Toggle/Toggle'

import {
  CardWrap,
  Section,
  SectionTitle,
  SectionTitleText,
} from 'features/trend-detection/features/issue-agent-detail/components/AgentInfoCard/styles'

export interface NotificationsCardProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

export const NotificationsCard: React.FC<NotificationsCardProps> = ({
  checked,
  onChange,
  disabled,
}) => (
  <CardWrap>
    <Section>
      <SectionTitle>
        <SectionTitleText forwardedAs="span">Notifications</SectionTitleText>
      </SectionTitle>
      <ToggleRow>
        <Toggle
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          aria-label="Email me this agent's findings after each run"
        />
        <Text $size="sm" as="span">
          Email me this agent&apos;s findings after each run
        </Text>
      </ToggleRow>
    </Section>
  </CardWrap>
)

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`
